// extracted by mini-css-extract-plugin
export default {"item":"Item_item__-Oh+f","avatar":"Item_avatar__77aCG","man":"Item_man__wpP-V","position":"Item_position__gHGxg"};